import script from "./OrganizerSidebarCreateTradeView.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganizerSidebarCreateTradeView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__